/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Current_Trip_Orders_EmptyInputs */

const vi_vehicle_current_trip_orders_empty = /** @type {(inputs: Vehicle_Current_Trip_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có đơn hàng nào gắn với chuyến này`)
};

/**

* @param {Vehicle_Current_Trip_Orders_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_current_trip_orders_empty = /** @type {((inputs?: Vehicle_Current_Trip_Orders_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Current_Trip_Orders_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_current_trip_orders_empty(inputs)
});